
import { SET_ORDER_TYPE_FILTER } from './ordersFilters-action';

const initialState = {};

const ordersFiltersReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_ORDER_TYPE_FILTER: {
        const { vitalsType, filter } = action.payload;
        return {
            ...state,
            [vitalsType]: filter,
        };
    }
    default:
        return state;
    }
};

export default ordersFiltersReducer;
